import { useState, useEffect } from "react";
import moment from "moment";

function People() {
  const [counter, setCounter] = useState(
    8_226_785_837 + moment(moment()).diff("2025-06-01", "seconds")
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const dif = Math.random() * (3 - -1) + -1;
      setCounter((prev) => prev + Math.floor(dif));
    }, 200);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      id="people"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <h1>
          Que sorte a minha...
          <br />
          <br />
          Existem <u>{counter.toLocaleString("pt-BR")}</u> pessoas no
          mundo neste momento, e ainda assim eu consegui encontrar você!
        </h1>
      </div>
    </div>
  );
}

export default People;
